import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignPersonalCalendarHolidaysRequestFailure({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isFailure : false;
    },
    isAssignPersonalCalendarHolidaysRequestPending({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isPending : false;
    },
    isAssignPersonalCalendarHolidaysRequestSuccess({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
